import { LocalJsonStorage } from './storage';

const STORAGE_KEY = 'history';
LocalJsonStorage.set({ key: STORAGE_KEY, value: {} });
function update(value) {
  LocalJsonStorage.set({ key: STORAGE_KEY, value });
}
function get() {
  return LocalJsonStorage.get(STORAGE_KEY) || {};
}

export const historyData = {
  update,
  get,
};
